import React from 'react'
import HeaderBack from '../../components/global/HeaderBack'
import MainHeader from '../../components/global/MainHeader';
import iconLogin from './../../assets/auth/LoginNew.png'
import WrapperSection from '../../components/global/WrapperSection';
import FormRegister from '../../components/auth/FormRegister';

const Register = () => {

  return (
    <>
      <HeaderBack />
      <MainHeader image={iconLogin} title={"Register"} />
      <WrapperSection>
        <FormRegister />
      </WrapperSection>
    </>
  )
}

export default Register